import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "app/hooks/useAuth";

export const RootRoutes = () => {
  const { authData } = useAuth();
  return authData?.need_data_pelanggan ? (
    <Navigate to="/customer/create" state={{ showDialog: true }} />
  ) : (
    <Navigate to="/customer" />
  );
};
export default RootRoutes;
